var themeColor = props => {
  switch (props.themeColor) {
    case 'primary':
      return props.theme.colors.primary;
    case 'secondary':
      return props.theme.colors.secondary;
    case 'tertiary':
      return props.theme.colors.tertiary;
    case 'info':
      return props.theme.colors.info;
    case 'success':
      return props.theme.colors.success;
    case 'warning':
      return props.theme.colors.warning;
    case 'error':
      return props.theme.colors.error;
    case 'dark':
      return props.theme.colors.dark;
    case 'light':
      return props.theme.colors.light;
    default:
      return props.theme.colors.neutral;
  }
};
export default themeColor;